var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DeviceAppBarPage",
    {
      attrs: { title: _vm.pageTitle },
      scopedSlots: _vm._u([
        {
          key: "subNav",
          fn: function () {
            return [_c("DeviceTopNav")]
          },
          proxy: true,
        },
      ]),
    },
    [
      !_vm.isPageLoading
        ? _c(
            "KPageContainer",
            { staticClass: "device-container" },
            [
              _vm.showDisabledAlert && _vm.alertDismissed
                ? _c(
                    "UiAlert",
                    {
                      attrs: { type: "warning" },
                      on: {
                        dismiss: function ($event) {
                          _vm.alertDismissed = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.disabledAlertText) + "\n\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _c("section", [
                _c("h1", [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$tr("pageHeader")) + "\n      "
                  ),
                ]),
                _c(
                  "p",
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$tr("pageDescription")) +
                        "\n        "
                    ),
                    !_vm.isMultiFacilitySuperuser &&
                    _vm.getFacilitySettingsPath()
                      ? _c("KExternalLink", {
                          attrs: {
                            text: _vm.$tr("facilitySettings"),
                            href: _vm.getFacilitySettingsPath(),
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("section", [
                _c(
                  "div",
                  { staticClass: "fieldset" },
                  [
                    _c("KSelect", {
                      staticStyle: { "max-width": "300px" },
                      attrs: {
                        label: _vm.$tr("selectedLanguageLabel"),
                        options: _vm.languageOptions,
                        disabled: _vm.language.value === undefined,
                        floatingLabel: false,
                      },
                      model: {
                        value: _vm.language,
                        callback: function ($$v) {
                          _vm.language = $$v
                        },
                        expression: "language",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "fieldset" },
                  [
                    _c("label", { staticClass: "fieldset-label" }, [
                      _vm._v(_vm._s(_vm.$tr("externalDeviceSettings"))),
                    ]),
                    _c("KCheckbox", {
                      attrs: {
                        label: _vm.$tr("unlistedChannels"),
                        checked: _vm.allowPeerUnlistedChannelImport,
                      },
                      on: {
                        change: function ($event) {
                          _vm.allowPeerUnlistedChannelImport = $event
                        },
                      },
                    }),
                    _vm.isAppContext
                      ? _c(
                          "KCheckbox",
                          {
                            attrs: { checked: _vm.allowOtherBrowsersToConnect },
                            on: {
                              change: function ($event) {
                                _vm.allowOtherBrowsersToConnect = $event
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$tr("allowExternalConnectionsApp")
                                  ) +
                                  "\n            "
                              ),
                              _vm.allowOtherBrowsersToConnect
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "description",
                                      style: {
                                        color: _vm.$themeTokens.annotation,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$tr(
                                              "allowExternalConnectionsAppDescription"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "fieldset" },
                  [
                    _c("label", { staticClass: "fieldset-label" }, [
                      _vm._v(_vm._s(_vm.$tr("landingPageLabel"))),
                    ]),
                    _c("KRadioButton", {
                      attrs: {
                        "data-test": "landingPageButton",
                        label: _vm.$tr("learnerAppPageChoice"),
                        value: _vm.landingPageChoices.LEARN,
                        currentValue: _vm.landingPage,
                      },
                      on: { input: _vm.handleLandingPageChange },
                    }),
                    _c("KRadioButton", {
                      attrs: {
                        "data-test": "signInPageButton",
                        label: _vm.$tr("signInPageChoice"),
                        value: _vm.landingPageChoices.SIGN_IN,
                        currentValue: _vm.landingPage,
                      },
                      on: { input: _vm.handleLandingPageChange },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "fieldset",
                        staticStyle: { "margin-left": "32px" },
                      },
                      [
                        _c("KRadioButton", {
                          attrs: {
                            "data-test": "allowGuestAccessButton",
                            label: _vm.$tr("allowGuestAccess"),
                            value: _vm.SignInPageOptions.ALLOW_GUEST_ACCESS,
                            currentValue: _vm.signInPageOption,
                            disabled: _vm.disableSignInPageOptions,
                          },
                          on: { input: _vm.handleSignInPageChange },
                        }),
                        _c("KRadioButton", {
                          attrs: {
                            "data-test": "disallowGuestAccessButton",
                            label: _vm.$tr("disallowGuestAccess"),
                            value: _vm.SignInPageOptions.DISALLOW_GUEST_ACCESS,
                            currentValue: _vm.signInPageOption,
                            disabled: _vm.disableSignInPageOptions,
                          },
                          on: { input: _vm.handleSignInPageChange },
                        }),
                        _c("KRadioButton", {
                          attrs: {
                            "data-test": "lockedContentButton",
                            label: _vm.$tr("lockedContent"),
                            value: _vm.SignInPageOptions.LOCKED_CONTENT,
                            currentValue: _vm.signInPageOption,
                            disabled: _vm.disableSignInPageOptions,
                          },
                          on: { input: _vm.handleSignInPageChange },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.deviceIsAndroid
                  ? _c(
                      "div",
                      { staticClass: "fieldset" },
                      [
                        _c("h2", [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$tr("allowDownloadOnMeteredConnection")
                              )
                            ),
                          ]),
                        ]),
                        _c("p", { staticClass: "info-description" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$tr(
                                  "DownloadOnMeteredConnectionDescription"
                                )
                              ) +
                              "\n        "
                          ),
                        ]),
                        _c("KRadioButton", {
                          attrs: {
                            label: _vm.$tr("doNotAllowDownload"),
                            value:
                              _vm.meteredConnectionDownloadOptions
                                .DISALLOW_DOWNLOAD_ON_METERED_CONNECTION,
                            currentValue: _vm.meteredConnectionDownloadOption,
                          },
                          on: {
                            input: _vm.handleMeteredConnectionDownloadChange,
                          },
                        }),
                        _c("KRadioButton", {
                          attrs: {
                            label: _vm.$tr("allowDownload"),
                            value:
                              _vm.meteredConnectionDownloadOptions
                                .ALLOW_DOWNLOAD_ON_METERED_CONNECTION,
                            currentValue: _vm.meteredConnectionDownloadOption,
                          },
                          on: {
                            input: _vm.handleMeteredConnectionDownloadChange,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  [
                    _c("h2", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tr("primaryStorage")) +
                          "\n        "
                      ),
                    ]),
                    _c("p", { staticClass: "info-description" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tr("primaryStorageDescription")) +
                          "\n        "
                      ),
                    ]),
                    _c(
                      "p",
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.primaryStorageLocation) +
                            "\n          "
                        ),
                        _c("KButton", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondaryStorageLocations.length >= 1,
                              expression:
                                "(secondaryStorageLocations.length >= 1)",
                            },
                          ],
                          class: { disabled: !_vm.multipleWritablePaths },
                          attrs: {
                            text: _vm.$tr("changeLocation"),
                            primary: true,
                            appearance: "basic-link",
                            disabled:
                              !_vm.multipleWritablePaths || _vm.isRemoteContent,
                          },
                          on: {
                            click: function ($event) {
                              _vm.showChangePrimaryLocationModal = true
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.browserLocationMatchesServerURL &&
                    _vm.secondaryStorageLocations.length === 0
                      ? _c("KButton", {
                          attrs: {
                            text: _vm.$tr("addLocation"),
                            disabled: _vm.isRemoteContent,
                            appearance: "raised-button",
                            secondary: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.showAddStorageLocationModal = true
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.browserLocationMatchesServerURL &&
                          _vm.secondaryStorageLocations.length > 0,
                        expression:
                          "browserLocationMatchesServerURL && (secondaryStorageLocations.length > 0)",
                      },
                    ],
                  },
                  [
                    _c("h2", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tr("secondaryStorage")) +
                          "\n        "
                      ),
                    ]),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.multipleReadOnlyPaths,
                            expression: "multipleReadOnlyPaths",
                          },
                        ],
                        staticClass: "info-description",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tr("secondaryStorageDescription")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._l(_vm.secondaryStorageLocations, function (path) {
                      return _c("p", { key: path.index }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(path) +
                            " " +
                            _vm._s(_vm.isWritablePath(path)) +
                            "\n        "
                        ),
                      ])
                    }),
                    _c("KButton", {
                      attrs: {
                        hasDropdown: "",
                        secondary: "",
                        appearance: "raised-button",
                        disabled: _vm.isRemoteContent,
                        text: _vm.coreString("optionsLabel"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "menu",
                            fn: function () {
                              return [
                                _c("KDropdownMenu", {
                                  attrs: {
                                    options: _vm.storageLocationOptions,
                                  },
                                  on: {
                                    select: function ($event) {
                                      return _vm.handleSelect($event)
                                    },
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        300712223
                      ),
                    }),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "fieldset" },
                  [
                    _c("h2", [
                      _c("label", [_vm._v(_vm._s(_vm.$tr("autoDownload")))]),
                    ]),
                    _c("KCheckbox", {
                      attrs: {
                        label: _vm.$tr("enableAutoDownload"),
                        checked: _vm.enableAutomaticDownload,
                        description: _vm.$tr("enableAutoDownloadDescription"),
                        disabled: _vm.isRemoteContent,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleCheckAutodownload(
                            "enableAutomaticDownload",
                            $event
                          )
                        },
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "fieldset left-margin" },
                      [
                        _c("KCheckbox", {
                          attrs: {
                            label: _vm.$tr("allowLearnersDownloadResources"),
                            checked: _vm.allowLearnerDownloadResources,
                            description: _vm.$tr(
                              "allowLearnersDownloadDescription"
                            ),
                            disabled: _vm.isRemoteContent,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleCheckAutodownload(
                                "allowLearnerDownloadResources",
                                $event
                              )
                            },
                          },
                        }),
                        _c("KCheckbox", {
                          attrs: {
                            label: _vm.$tr("setStorageLimit"),
                            checked: _vm.setLimitForAutodownload,
                            description: _vm.$tr("setStorageLimitDescription"),
                            disabled: _vm.isRemoteContent,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleCheckAutodownload(
                                "setLimitForAutodownload",
                                $event
                              )
                            },
                          },
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.setLimitForAutodownload,
                                expression: "setLimitForAutodownload",
                              },
                            ],
                            staticClass: "left-margin",
                            attrs: { disabled: _vm.isRemoteContent },
                          },
                          [
                            _c("KTextbox", {
                              ref: "autoDownloadLimit",
                              staticClass: "download-limit-textbox",
                              attrs: {
                                disabled:
                                  _vm.notEnoughFreeSpace || _vm.isRemoteContent,
                                type: "number",
                                label: _vm.$tr("sizeInGigabytesLabel"),
                                min: 0,
                                max: _vm.freeSpace,
                                invalid: _vm.notEnoughFreeSpace,
                                invalidText: _vm.$tr("notEnoughFreeSpace"),
                              },
                              model: {
                                value: _vm.limitForAutodownload,
                                callback: function ($$v) {
                                  _vm.limitForAutodownload = $$v
                                },
                                expression: "limitForAutodownload",
                              },
                            }),
                            _c("div", { staticClass: "slider-section" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.limitForAutodownload,
                                    expression: "limitForAutodownload",
                                  },
                                ],
                                class: _vm.$computedClass(_vm.sliderStyle),
                                attrs: {
                                  id: "slider",
                                  disabled:
                                    _vm.notEnoughFreeSpace ||
                                    _vm.isRemoteContent,
                                  type: "range",
                                  min: "0",
                                  max: _vm.freeSpace,
                                  step: "1",
                                },
                                domProps: { value: _vm.limitForAutodownload },
                                on: {
                                  __r: function ($event) {
                                    _vm.limitForAutodownload =
                                      $event.target.value
                                  },
                                },
                              }),
                              _c("div", { staticClass: "slider-constraints" }, [
                                _c("p", { staticClass: "slider-min-max" }, [
                                  _vm._v(
                                    "\n                  0\n                "
                                  ),
                                ]),
                                _c("p", { staticClass: "slider-min-max" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.freeSpace) +
                                      "\n                "
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "fieldset" },
                  [
                    _c("h2", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tr("enabledPages")) +
                          "\n        "
                      ),
                    ]),
                    _c("p", { staticClass: "info-description" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.deviceString("newEnabledPluginsState")) +
                          "\n        "
                      ),
                    ]),
                    _vm._l(_vm.dataPlugins, function (plugin) {
                      return _c("KCheckbox", {
                        key: plugin.id,
                        attrs: {
                          label: plugin.name,
                          checked: plugin.enabled,
                          disabled: !_vm.canRestart,
                        },
                        on: {
                          change: function ($event) {
                            plugin.enabled = $event
                          },
                        },
                      })
                    }),
                  ],
                  2
                ),
              ]),
              _vm.isMultiFacilitySuperuser
                ? _c("section", [
                    _c("h2", [
                      _vm._v(
                        _vm._s(_vm.$tr("configureFacilitySettingsHeader"))
                      ),
                    ]),
                    _c(
                      "ul",
                      { staticClass: "ul-reset" },
                      [
                        _vm._l(_vm.facilities, function (facility, idx) {
                          return _c(
                            "li",
                            { key: idx },
                            [
                              _c("KExternalLink", {
                                attrs: {
                                  text: facility.name,
                                  href: _vm.getFacilitySettingsPath(
                                    facility.id
                                  ),
                                  icon: "facility",
                                },
                              }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm.deviceIsAndroid || _vm.isAppContext
                ? _c(
                    "section",
                    { staticClass: "android-bar" },
                    [
                      _c("KButton", {
                        attrs: {
                          text: _vm.coreString("saveChangesAction"),
                          appearance: "raised-button",
                          primary: "",
                          "data-test": "saveButtonAndroid",
                        },
                        on: { click: _vm.handleClickSave },
                      }),
                    ],
                    1
                  )
                : _c(
                    "BottomAppBar",
                    [
                      _c(
                        "KButtonGroup",
                        [
                          _c("KButton", {
                            attrs: {
                              text: _vm.coreString("saveChangesAction"),
                              appearance: "raised-button",
                              primary: "",
                              "data-test": "saveButton",
                            },
                            on: { click: _vm.handleClickSave },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _vm.showChangePrimaryLocationModal
                ? _c("PrimaryStorageLocationModal", {
                    attrs: {
                      primaryPath: _vm.primaryStorageLocation,
                      storageLocations: _vm.storageLocations.filter(function (
                        el
                      ) {
                        return el.writable
                      }),
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.showChangePrimaryLocationModal = false
                      },
                      submit: _vm.changePrimaryLocation,
                    },
                  })
                : _vm._e(),
              _vm.showAddStorageLocationModal
                ? _c("AddStorageLocationModal", {
                    attrs: { paths: _vm.storageLocations },
                    on: {
                      cancel: function ($event) {
                        _vm.showAddStorageLocationModal = false
                      },
                      submit: _vm.addStorageLocation,
                    },
                  })
                : _vm._e(),
              _vm.showRemoveStorageLocationModal
                ? _c("RemoveStorageLocationModal", {
                    attrs: { storageLocations: _vm.secondaryStorageLocations },
                    on: {
                      cancel: function ($event) {
                        _vm.showRemoveStorageLocationModal = false
                      },
                      submit: _vm.removeStorageLocation,
                    },
                  })
                : _vm._e(),
              _vm.showRestartModal
                ? _c("ServerRestartModal", {
                    attrs: {
                      path: _vm.restartPath,
                      changedSetting: _vm.restartSetting,
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.showRestartModal = false
                      },
                      submit: _vm.handleServerRestart,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }